<template>
  <div>
		<member-header></member-header>
		<div class="_content clearfix_">
			<div class="fl _content_l">
				<ul>
					<li class="_superior" v-for="(item,index) in classificationList" :key="index">
						<div class="_txt clearfix_">
							<img class="fl" :src="item.pic" alt="">
							<p :style="(idx_==item.id?'color:#dd2c3a;':'')" @click="gotoLink(item.link,item.id)" class="fl">{{item.title}}</p>
						</div>
						<ul>
							<!-- <li class="_subordinate" v-for="(val,idx) in item.value" :key="idx"><router-link tag="a" target="_blank" :to="{name:val.link,query:{}}">{{val.txt}}</router-link></li> -->
							<li class="_subordinate" v-for="(val,idx) in item.value" :key="idx"><span :style="(idx_==val.id?'color:#dd2c3a;':'')" @click="gotoDetailsLink(val.link,val.queryData,val.id)">{{val.txt}}</span></li>
						</ul>
					</li>
				</ul>
			</div>
			<div class="fr _content_r">
				<router-view v-if="isRouterAlive1"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
import '../../assets/css/reset.css'
import memberHeader from '@/components/member/member_header'
export default {
	components:{
		memberHeader
  },
  data () {
    return {
			isRouterAlive1:true,
			idx_:-1,
			classificationList:[
				{
					title:'订单中心',
					pic:require('../../assets/img/order_.png'),
					value:[
						{
							id:0,
							txt:'我的订单',
							link:'order',
							queryData:{
								state:0
							}
						},
						{
							id:1,
							txt:'退货退款',
							link:'returnGoodsList'
						},
						{
							id:2,
							txt:'我的评价',
							link:'myEvaluation',
						}
					]
				},
				{
					title:'拼团中心',
					pic:require('../../assets/img/team.png'),
					value:[
						{
							id:3,
							txt:'我的拼团',
							link:'teamOrder',
							queryData:{
								state:0
							}
						},
						// {
						// 	id:4,
						// 	txt:'已成团',
						// 	link:'teamOrder',
						// 	queryData:{
						// 		state:2
						// 	}
						// }
					]
				},
				{
					title:'关注中心',
					pic:require('../../assets/img/follow_.png'),
					value:[
						{
							id:5,
							txt:'我的收藏',
							link:'collections'
						},
						{
							id:6,
							txt:'我的足迹',
							link:'footprint'
						},
						{
							id:7,
							txt:'店铺活动',
							link:'activityList'
						}
					]
				},
				{
					title:'账户管理',
					pic:require('../../assets/img/Administration_.png'),
					value:[
						{
							id:8,
							txt:'地址管理',
							link:'address'
						},
						{
							id:9,
							txt:'个人信息',
							link:'information'
						},
						{
							id:10,
							txt:'下单密码',
							link:'payPassword',
							// queryData:{
							// 	step:1
							// }
						},
						{
							id:11,
							txt:'登录密码',
							link:'SetPWD1',
							queryData:{
								step:1
							}
						}
					]
				},
				{
					title:'我的资产',
					pic:require('../../assets/img/Assets_.png'),
					value:[
						{
							txt:'资产列表',
							link:'allTenant',
							id:12
						}
					]
				}
			],
    }
	},
	mounted:function(){
		if(this.$route.query.listId)this.idx_=this.$route.query.listId
	},
	methods:{
		gotoDetailsLink:function(link,obj,id){
			if(!link)return
			this.idx_=id
			if(obj){
				if(id==11||id==10){
					var href=this.$router.resolve({name:link,query:obj})
					window.open(href.href,'_blank')
				}else{
					this.$router.push({name:link,query:obj})
				}
			}else{
				if(id==11||id==10){
					var href=this.$router.resolve({name:link})
					window.open(href.href,'_blank')
				}else{
					this.$router.push({name:link})
				}
			}
      let query = this.$router.history.current.query
      let path = this.$router.history.current.path
      let newQuery = JSON.parse(JSON.stringify(query))
      newQuery.listId = this.idx_
			this.$router.push({ path, query: newQuery })
			
		},
		gotoLink:function(link,id){
			if(!link)return
			this.idx_=id
			return this.$router.push({name:link})
			// var href=this.$router.resolve({name:link})
      // return window.open(href.href,'_blank')
		},
		reload:function(){
			this.isRouterAlive1=false
			this.$nextTick(function(){
				this.isRouterAlive1=true
			})
		},
	}
}
</script>
<style>
	body{
		background: #f5f5f5;
	}
	._content{
		width: 1200px;
		margin: 0 auto;
	}
	._content_l{
		width: 160px;
		background: #fff;
	}
	._content_l>ul{
		margin: 23px 0 0 23px;
	}
	._content_l ._txt{
		font-weight: 900;
	}
	._content_l ._txt img{
		width: 16px;
		height: 16px;
		margin-right: 5px;
		margin-top: 2px;
	}
	._content_l ._txt p{
		font-size:14px;
		line-height:20px;
		margin-bottom: 12px;
		cursor: pointer;
		color:#222;
	}
	._subordinate{
		margin: 0 0 12px 22px;
		font-weight: 100;
		color:#666;
		cursor: pointer;
	}
	._subordinate:hover{
		color:#dd2c3a;
	}
	._content_r{
		width: 1030px;
		padding-top: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/member/index.vue